import type {
  ConversationRef,
  RenderConversationAccessory,
} from '@cowbell/moo';
import ActiveRunCountBadge from '../../components/sidebars/ActiveRunCountBadge';
import {
  normalizeConversationId,
  useActiveAsyncRuns,
} from '../../hooks/useActiveAsyncRuns';

/** Drawer-row accessory: subscribes to the shared active-runs poll so the
 *  config callback stays referentially stable while counts update. */
function ConversationActiveRunBadge({
  conversationId,
}: Readonly<{ conversationId: string }>) {
  const counts = useActiveAsyncRuns();
  return (
    <ActiveRunCountBadge
      count={counts[normalizeConversationId(conversationId)] ?? 0}
    />
  );
}

export const renderConversationAccessory: RenderConversationAccessory = (
  conversation: ConversationRef
) => <ConversationActiveRunBadge conversationId={conversation.id} />;
